import * as React from 'react'

import { LIST_PAYMENTS, RESET_DATA, UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { ResultConcepts, ResultConceptsType } from 'modules/payroll_bundle/lib/constants'
import type Payment from 'modules/payroll_bundle/store/models/Payment'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

export type PaymentStage = 'SELECT_DATA' | 'LIST_PAYMENT'
export type ActionTypes = 'RESET_DATA' | 'UPDATE_DATA'

export interface ResetDataAction {
  type: 'RESET_DATA'
}

export interface UpdateDataAction {
  type: 'UPDATE_DATA'
  payload: Partial<State>
}

export type Actions = ResetDataAction | UpdateDataAction

export interface PaymentData {
  employee_id: number
  amount: number
  bank_account: string
}

export interface State {
  selectedPayments: Set<number>
  paymentList: PaymentItem[]
  paymentDetailsToShow?: Payment
  generatedPayments: PaymentData[]
  paymentStage: PaymentStage
  selectedConcept: ResultConceptsType
  showSelectConceptModal: boolean
  paymentConceptType: ResultConceptsType
  showPaymentDetailsSidepanel: boolean
  paymentDispatch: React.Dispatch<Actions>
}

const initialState: State = {
  selectedPayments: new Set([]),
  paymentList: [],
  paymentDetailsToShow: undefined,
  generatedPayments: [],
  paymentStage: LIST_PAYMENTS,
  selectedConcept: ResultConcepts.regular_payroll,
  showSelectConceptModal: false,
  paymentConceptType: ResultConcepts.regular_payroll,
  showPaymentDetailsSidepanel: false,
  paymentDispatch: () => {
    // Do nothing
  },
}

const payrollPaymentsContext: React.Context<State> = React.createContext(initialState)

const PayrollPaymentsProvider = payrollPaymentsContext.Provider

function reducer(state: State, action: Actions): State {
  switch (action.type) {
    case UPDATE_DATA:
      return { ...state, ...action.payload }
    case RESET_DATA:
      return initialState
    default:
      throw new Error()
  }
}

interface Props {
  children: React.ReactNode
}

export const PayrollPaymentsContextProvider = ({ children }: Props) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  return (
    <PayrollPaymentsProvider value={{ ...state, paymentDispatch: dispatch }}>
      {children}
    </PayrollPaymentsProvider>
  )
}

export const usePayrollPayments = () => {
  const payrollPayments = React.useContext(payrollPaymentsContext)

  if (!payrollPayments) {
    throw new Error('usePayrollPayments hook must be used within a PayrollPaymentsContextProvider')
  }

  return payrollPayments
}
